"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ViewToggleButton = exports.BatchActionDropdown = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _classnames = _interopRequireDefault(require("classnames"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
var _Dashboard = _interopRequireDefault(require("@material-ui/icons/Dashboard"));
var _ViewList = _interopRequireDefault(require("@material-ui/icons/ViewList"));
var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["children", "icon", "textAlign"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var useStyles = (0, _styles.makeStyles)({
  paper: {
    backgroundColor: 'transparent'
  }
});
var Layout = function Layout(_ref) {
  var left = _ref.left,
    right = _ref.right;
  var hasChildren = (0, _react.useMemo)(function () {
    return _react["default"].Children.count(left) !== 0 || _react["default"].Children.count(right) !== 0;
  }, [left, right]);
  if (!hasChildren) return null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center h-10"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full flex flex-1 justify-start items-center"
  }, _react["default"].Children.map(left, function (node, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "left-".concat(index),
      className: "px-3 first:pl-0"
    }, node);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full flex flex-1 justify-end items-center"
  }, _react["default"].Children.map(right, function (node, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "right-".concat(index),
      className: "px-3 last:pr-6"
    }, node);
  })));
};
var BatchActionDropdown = exports.BatchActionDropdown = function BatchActionDropdown(_ref2) {
  var main = _ref2.main,
    options = _ref2.options;
  var classes = useStyles();
  var anchorRef = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  function handleOnToggle() {
    setOpen(function (prevState) {
      return !prevState;
    });
  }
  function handleOnClose(event) {
    setOpen(false);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: anchorRef,
    className: "flex items-center rounded overflow-hidden"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "sm",
    onClick: main.onClick,
    className: "!px-4"
  }, /*#__PURE__*/_react["default"].createElement(TextWithIcon, {
    icon: main.icon
  }, main.title)), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "sm",
    active: open,
    onClick: handleOnToggle
  }, /*#__PURE__*/_react["default"].createElement(TextWithIcon, {
    icon: /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null)
  }))), /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    open: open,
    elevation: 2,
    classes: classes,
    onClose: handleOnClose,
    anchorEl: anchorRef.current,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "bg-card",
    style: {
      width: anchorRef.current ? anchorRef.current.clientWidth : 'auto'
    }
  }, options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: "option-".concat(index),
      className: "cursor-pointer hover:bg-secondary"
    }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      className: "w-full !px-4 !py-3",
      onClick: function onClick() {
        option.onClick();
        handleOnToggle();
      }
    }, /*#__PURE__*/_react["default"].createElement(TextWithIcon, {
      textAlign: "left",
      icon: option.icon
    }, option.title)));
  }))));
};
var viewToggleValues = {
  preview: {
    icon: /*#__PURE__*/_react["default"].createElement(_Dashboard["default"], null),
    title: 'Preview'
  },
  list: {
    icon: /*#__PURE__*/_react["default"].createElement(_ViewList["default"], null),
    title: 'List'
  }
};
var ViewToggleButton = exports.ViewToggleButton = function ViewToggleButton(_ref3) {
  var value = _ref3.value,
    onClick = _ref3.onClick;
  var _get = (0, _get2["default"])(viewToggleValues, value, viewToggleValues.preview),
    icon = _get.icon,
    title = _get.title;
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    rounded: true,
    size: "sm",
    color: "secondary",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(TextWithIcon, {
    icon: icon
  }, title));
};
var TextWithIcon = function TextWithIcon(_ref4) {
  var children = _ref4.children,
    icon = _ref4.icon,
    _ref4$textAlign = _ref4.textAlign,
    textAlign = _ref4$textAlign === void 0 ? 'center' : _ref4$textAlign,
    props = (0, _objectWithoutProperties2["default"])(_ref4, _excluded);
  return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({
    className: (0, _classnames["default"])('text-xs flex items-center', {
      'justify-center': textAlign === 'center',
      'justify-start': textAlign === 'left',
      'justify-end': textAlign === 'right'
    })
  }, props), children && /*#__PURE__*/_react["default"].createElement("span", null, children), icon && /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-2 first:ml-0 text-lg flex"
  }, /*#__PURE__*/_react["default"].cloneElement(icon, {
    fontSize: 'inherit'
  })));
};
var _default = exports["default"] = Layout;
//# sourceMappingURL=index.js.map